import React from 'react'
import ReactDOM from 'react-dom'

import Img from 'gatsby-image'

import './gallery.css'

export default class Gallery extends React.Component {
  state = { id: null }

  handleImageClick = event => {
    if (CSS && CSS.supports('(object-fit: contain)')) {
      event.preventDefault()
      const index = parseInt(event.currentTarget.dataset.index, 10)
      console.log(event.target.dataset, index)
      this.setState({ id: index })
    }
  }

  changeId = id => {
    this.setState({ id })
  }

  render() {
    const { images } = this.props
    const { id } = this.state

    return (
      <React.Fragment>
        <div className="gallery">
          {images.map((image, index) => (
            <a
              key={index}
              href={image.sizes.src}
              target="_blank"
              rel="noopener"
              data-index={index}
              onClick={this.handleImageClick}
            >
              <Img resolutions={image.resolutions} />
            </a>
          ))}
        </div>
        {typeof id === 'number' && (
          <Modal image={images[id]} changeId={this.changeId} />
        )}
      </React.Fragment>
    )
  }
}

class Modal extends React.Component {
  render() {
    return ReactDOM.createPortal(this.renderContent(), document.body)
  }

  handleExit = () => {
    this.props.changeId(null)
  }

  renderContent() {
    const { image } = this.props

    return (
      <button className="modal" onClick={this.handleExit}>
        <Img sizes={image.sizes} imgStyle={{ objectFit: 'contain' }} />
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/gallery/index.js